import React from 'react';
import { CheckCircle2, XCircle } from 'lucide-react';

interface FormStatusProps {
  error: string | null;
  success: boolean;
  successMessage: string;
}

const FormStatus: React.FC<FormStatusProps> = ({ error, success, successMessage }) => {
  if (error) {
    return (
      <div className="bg-red-50 border-2 border-red-200 rounded-xl p-4 animate-in fade-in slide-in-from-top-2 duration-300">
        <div className="flex items-start">
          <XCircle className="h-5 w-5 text-red-600 mt-0.5 flex-shrink-0" />
          <div className="ml-3">
            <h3 className="text-sm font-semibold text-red-800">Error</h3>
            <p className="text-sm text-red-700 mt-1">{error}</p>
          </div>
        </div>
      </div>
    );
  }

  if (success) {
    return (
      <div className="bg-green-50 border-2 border-green-200 rounded-xl p-4 animate-in fade-in slide-in-from-top-2 duration-300">
        <div className="flex items-start">
          <CheckCircle2 className="h-5 w-5 text-green-600 mt-0.5 flex-shrink-0" />
          <div className="ml-3">
            <h3 className="text-sm font-semibold text-green-800">Success!</h3>
            <p className="text-sm text-green-700 mt-1">{successMessage}</p>
          </div>
        </div>
      </div>
    );
  }

  return null;
};

export default FormStatus;